let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7YTOn")).then(() => parcelRequire('2ws0G'));